import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

const useShowClearByLearnEdTooltip = () => {
  const [showClearByLearnEdTooltip, setShowClearByLearnEdTooltip] = useLocalStorage(
    'learned_show_clear_tooltip',
    true
  );
  return [
    showClearByLearnEdTooltip ?? true,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(() => setShowClearByLearnEdTooltip(false), []),
  ];
};

export default useShowClearByLearnEdTooltip;
